export class EnrollmentReportItem {
    auditId: string;
    approverName: string;
    approvalDate: string;
    enrollmentStatus: string;
    reportedBy: string | null;
    enrollmentGroups: string;
    enrollmentDate: string;
    location: string;
    reportedLoss: string;
    caseEventType: string | null;
    activityType: string | null;
    caseNumber: string | null;
    userName: string;

    constructor(item: any) {
        let approverName = (item.approver != null && (item.approver?.firstName === '' || item.approver?.lastName === '')) ? item.approver?.userName : `${item.approver?.lastName}, ${item.approver?.firstName}`;
        this.approverName = item.approver != null ? approverName : "";
        this.approvalDate = item.approvalDate != null ? new Date(item.approvalDate).toLocaleString() : '';
        this.enrollmentStatus = item.approver != null ? item.enrollmentStatus : "Pending";
        this.reportedBy = item.reportedBy;
        //@ts-ignore
        this.enrollmentGroups = item.enrollmentGroups.map(eg => eg.name).join(', ') //To Do: Create the list of group names
        this.enrollmentDate = item.enrollmentDate != null ? new Date(item.enrollmentDate).toLocaleString() : '';
        this.location = item.location;
        this.reportedLoss = item.reportedLoss;
        this.caseEventType = item.caseEventType;
        this.activityType = item.activityType;
        this.auditId = item.auditId;
        this.caseNumber = item.caseNumber;
        
        let userName = (item.user != null && (item.user?.firstName === '' || item.user?.lastName === '')) ? item.user?.userName : `${item.user?.lastName}, ${item.user?.firstName}`;
        this.userName =  userName;
    }
}

export interface AuditedUser {
    id: string;
    firstName: string;
    lastName: string;
}

export interface EnrollmentGroup {
    id: string;
    name: string;
}

export interface FilterCriteria {
    reportType: string;
    filterBy: string;
    Users: User[];
}

export interface User {
    id: string
    name: string
};

export interface AuditLogReportRequest {
    startDate: string;
    endDate: string;
    userIds: string[]
}

export class LoginLogoutRow {
    userName: string;
    date: string;
    timeLogIn: string;
    timeLogOut: string;
    totalHours: number;
    ipAddress: string;
    type: string;

    constructor(row: any) {
        this.userName = row.user;
        this.date = row.date != null ? new Date(row.date).toLocaleDateString() : "";
        this.timeLogIn = row.timeLogIn != null ? new Date(row.timeLogIn).toLocaleTimeString() :"";
        this.timeLogOut = row.timeLogOut != null ? new Date(row.timeLogOut).toLocaleTimeString() : "";
        this.totalHours = row.totalHours;
        this.ipAddress = row.ipAddress;
        this.type = row.type;
    }
}

export class ThresholdChangeReportItem {
    userName: string;
    enrollmentGroup: string;
    seriousOffenderChange: string;
    type: string;
    thresholdChange: string;
    changeResult: number;
    changedDate: string;
    changedTime: string;
    ipAddress: string;
    
    constructor(row: any) {
        this.changedDate = new Date(row.changedDateTime).toLocaleDateString();
        this.changedTime = new Date(row.changedDateTime).toLocaleTimeString();
        this.changeResult = row.changeResult ?? "";
        this.enrollmentGroup = row.enrollmentGroup;
        this.ipAddress = row.ipAddress;
        this.seriousOffenderChange = row.oldSeriousOffender != null && row.newSeriousOffender != null ?`${row.oldSeriousOffender} -> ${row.newSeriousOffender}` : "";
        this.thresholdChange = row.oldThreshold != null && row.newThreshold != null ? `${row.oldThreshold} -> ${row.newThreshold}` : "";
        this.type = row.type;
        this.userName = row.user;
    }
}

export const auditLogReports: {[key: string]:  {id:string, title: string}} = {
    approverEnrollments: {id: 'approverEnrollments', title: 'Approver Enrollments'},
    userEnrollments: {id:'userEnrollments', title: 'User Enrollments'},
    loginLogout: {id: 'loginLogout', title: 'Login Logout'},
    thresholdChanges: {id:'thresholdChanges', title:'Threshold Changes'},
}